/**
 * Determines whether a value is "falsy" in an extended business sense.
 *
 * Covered cases:
 * - `null` or `undefined`
 * - boolean `false`
 * - number ≤ 0 (zero or negative)
 * - empty string `""`
 * - empty array `[]`
 * - empty object `{}`
 *
 * @param element - The value to evaluate (`unknown` type to enforce explicit type narrowing).
 * @returns `true` if the value is considered falsy, `false` otherwise.
 */
export function isFalsy(element: unknown): boolean {
  if (element === null || element === undefined) return true;

  if (typeof element === 'boolean') return element === false;

  if (typeof element === 'number' || (typeof element === 'string' && !isNaN(+element) && +element <= 0))
    return +element <= 0;

  if (typeof element === 'string') return element.trim() === '';

  if (Array.isArray(element)) return element.length === 0;

  if (typeof element === 'object') return Object.keys(element as object).length === 0;

  return false;
}
